import React, { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";
import Navbar from "@/components/public/Navbar";
import Hero from "@/components/public/Hero";
import BrandStory from "@/components/public/BrandStory";
import Flavors from "@/components/public/Flavors";
import Statement from "@/components/public/Statement";
import OrderForm from "@/components/public/OrderForm";
import Reviews from "@/components/public/Reviews";
import Outlets from "@/components/public/Outlets";
import Contact from "@/components/public/Contact";
import Footer from "@/components/public/Footer";
import WhatsAppButton from "@/components/public/WhatsAppButton";

export default function Landing() {
  const [products, setProducts] = useState([]);
  const [settings, setSettings] = useState({});
  const [reviews, setReviews] = useState([]);
  const [outlets, setOutlets] = useState([]);

  const loadReviews = useCallback(async () => {
    try { const { data } = await api.get("/reviews"); setReviews(data); } catch { /* noop */ }
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const [p, s, o] = await Promise.all([api.get("/products"), api.get("/settings"), api.get("/outlets")]);
        setProducts(p.data); setSettings(s.data); setOutlets(o.data);
      } catch { /* noop */ }
    })();
    loadReviews();
  }, [loadReviews]);

  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <div className="grain relative min-h-screen bg-sfc-night">
      <Navbar />
      <main>
        <Hero settings={settings} onOrder={() => scrollTo("bestellen")} onDiscover={() => scrollTo("smaken")} />
        <BrandStory settings={settings} />
        <Flavors products={products} onOrder={() => scrollTo("bestellen")} />
        <Statement settings={settings} onOrder={() => scrollTo("bestellen")} />
        <OrderForm products={products} />
        <Reviews reviews={reviews} onSubmitted={loadReviews} />
        <Outlets outlets={outlets} />
        <Contact settings={settings} />
      </main>
      <Footer settings={settings} />
      <WhatsAppButton settings={settings} />
    </div>
  );
}
